"use strict";import{css as s}from"@spectrum-web-components/base";const t=s`
    
`;export default t;
//# sourceMappingURL=lang-overrides.css.js.map
